<section class="users-page">
  <div class="users-card">
    <header class="users-header">
      <h1 class="sam-page-heading">ANVÄNDARE ({{ allCount }})</h1>

      <mat-menu #usersMenu="matMenu">
        <button *ngIf="isAdmin"
                mat-menu-item
                type="button"
                (click)="getExcelReport()">
          <mat-icon>download</mat-icon>
          Medlemslista
        </button>

        <button *ngIf="isAdmin || (isCompanyUser && isParentAccount)"
                mat-menu-item
                type="button"
                (click)="createNewUser()">
          <mat-icon>add</mat-icon>
          Ny användare
        </button>

      </mat-menu>

      <button mat-icon-button
              type="button"
              class="user-actions"
              [matMenuTriggerFor]="usersMenu"
              aria-label="Fler alternativ">
        <mat-icon>more_vert</mat-icon>
      </button>
    </header>

    <div class="filter-bar">
      <label class="search-box">
        <mat-icon>search</mat-icon>
        <input type="search"
               [formControl]="searchControl"
               placeholder="Sök efter namn, e-post eller personnummer..."
               aria-label="Sök användare">
        <button *ngIf="searchControl.value"
                mat-icon-button
                type="button"
                aria-label="Rensa sökfält"
                (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </label>

      <button class="reset-filter"
              mat-icon-button
              type="button"
              aria-label="Återställ filter"
              matTooltip="Återställ filter"
              (click)="resetFilters()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="table-shell">
      <div class="table-scroll">
        <div *ngIf="isLoading" class="table-skeleton" aria-hidden="true">
          <div class="skeleton-row" *ngFor="let _ of [1,2,3,4,5]">
            <span class="skeleton-avatar"></span>
            <span class="skeleton-cell skeleton-name"></span>
            <span class="skeleton-cell skeleton-number"></span>
            <span class="skeleton-cell skeleton-personal-number"></span>
            <span class="skeleton-cell skeleton-email"></span>
            <span class="skeleton-cell skeleton-date"></span>
            <span class="skeleton-cell skeleton-date"></span>
            <span class="skeleton-cell skeleton-status"></span>
            <span class="skeleton-cell skeleton-actions"></span>
          </div>
        </div>

        <table mat-table
               [class.users-table-loading]="isLoading"
               [dataSource]="dataSource"
               matSort
               (matSortChange)="sortData($event)"
               matSortActive="name"
               matSortDirection="asc"
               matSortDisableClear>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Namn / kontakt</th>
            <td mat-cell *matCellDef="let row" class="name-cell" (click)="openUserPage(row, $event)">
              <span class="avatar" [attr.data-tone]="getAvatarTone(row)">
                {{ getInitials(row) }}
                <span class="presence" [class.suspended]="row?.Suspended"></span>
              </span>
              <span class="person-details">
                <strong>{{ row?.FirstName }} {{ row?.LastName }}</strong>
                <small>{{ row?.Email || 'Ingen e-postadress' }}</small>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="memberNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nr</th>
            <td mat-cell *matCellDef="let row" (click)="openUserPage(row, $event)">{{ row?.MemberNumber || '–' }}</td>
          </ng-container>

          <ng-container matColumnDef="personalNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Personnummer</th>
            <td mat-cell *matCellDef="let row" (click)="openUserPage(row, $event)">{{ row?.PersonalNumber || '–' }}</td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>E-postadress</th>
            <td mat-cell *matCellDef="let row" class="email-cell">
              <button type="button"
                      class="email-button"
                      matTooltip="Kopiera e-postadress"
                      (click)="$event.stopPropagation(); copyEmail(row?.Email)">
                {{ row?.Email || '–' }}
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Medlem sedan</th>
            <td mat-cell *matCellDef="let row">
              {{ (row?.Created === '0001-01-01T00:00:00' ? null : row?.Created) | swedishDate:'yyyy-MM-dd' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="lastLogin">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Senast inloggad</th>
            <td mat-cell *matCellDef="let row">
              {{ (row?.LastLogin === '2017-01-01T00:00:00' ? null : row?.LastLogin) | swedishDate:'yyyy-MM-dd' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="suspended">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Spärr</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-pill" [class.blocked]="row?.Suspended">
                <mat-icon>{{ row?.Suspended ? 'lock' : 'lock_open' }}</mat-icon>
                {{ row?.Suspended ? 'Spärrad' : 'Aktiv' }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Åtgärder</th>
            <td mat-cell *matCellDef="let row" class="actions-cell">
              <button mat-icon-button
                      type="button"
                      aria-label="Redigera användare"
                      matTooltip="Redigera användare"
                      (click)="$event.stopPropagation(); openUserPage(row, $event)">
                <mat-icon>edit</mat-icon>
              </button>

              <button mat-icon-button
                      type="button"
                      aria-label="Fler åtgärder"
                      [matMenuTriggerFor]="rowMenu"
                      (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #rowMenu="matMenu">
                <button *ngIf="canImpersonate(row)" mat-menu-item (click)="confirmImpersonation(row)">
                  <mat-icon>login</mat-icon>
                  Logga in som användaren
                </button>
                <button *ngIf="isAdmin" mat-menu-item (click)="addInvoice(row)">
                  <mat-icon>note_add</mat-icon>
                  Ny faktura
                </button>
                <button *ngIf="isAdmin" mat-menu-item (click)="addJobPreNotification(row)">
                  <mat-icon>assignment</mat-icon>
                  Ny föranmälan
                </button>
                <button *ngIf="isAdmin" mat-menu-item class="danger-menu-item" (click)="delete(row)">
                  <mat-icon>delete</mat-icon>
                  Radera
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div *ngIf="!isLoading && !dataSource.data.length" class="empty-state">
          <mat-icon>person_search</mat-icon>
          <strong>Inga användare hittades</strong>
          <span>Prova att ändra sökningen eller filtreringen.</span>
        </div>
      </div>

      <mat-paginator [length]="totalCount"
                     [pageSize]="pageSize"
                     [pageIndex]="pageIndex"
                     [pageSizeOptions]="[5, 10, 20, 50]"
                     [showFirstLastButtons]="true"
                     (page)="onPageChange($event)">
      </mat-paginator>
    </div>
  </div>
</section>
